export const MY_TIMERS_TYPES = {
  MY_TIMERS: 'myTimers',
  MY_TIMERS_WITH_POPULAR_MEDITATIONS: 'myTimersWithPopularMeditations',
}
